module.exports = __webpack_public_path__ + "static/media/banner-black.e37d5429.png";